// Seed prize content for the shop & reveal (frontend-first), matching the Figma
// design. In production this becomes CMS-managed per cycle (Shop/Reveal CMS).
import verstappen from '@/assets/v3/prizes/verstappen-pet.webp'
import streamers from '@/assets/v3/prizes/streamers.webp'
import streamersBg from '@/assets/v3/prizes/streamers-bg.webp'
import theater from '@/assets/v3/prizes/theater.webp'

export const PRIZES = [
  {
    id: 'verstappen-pet',
    title: 'Max Verstappen pet',
    subtitle: 'New Era Max Verstappen Drive Cap',
    infoTitle: 'New Era Max Verstappen Drive Cap',
    info: 'Draag ‘m tijdens de race of gewoon daarbuiten. Officiële New Era Max Verstappen Drive Cap.',
    color: '#060c2b',
    image: verstappen,
  },
  {
    id: 'streamers',
    title: 'Als VIP naar The Streamers',
    subtitle: 'Win 2 VIP tickets voor The Streamers in de Ziggo Dome',
    infoTitle: 'Win 2 VIP naar The Streamers (1x)',
    info: 'The Streamers vieren hun 5-jarig jubileum groots in de Ziggo Dome. Je wint kaarten voor 2 personen op 20 september. Verwacht een muzikale avond vol bekende hits, verrassingen, slingers en confetti, met artiesten als Guus Meeuwis, Snelle, Miss Montréal, Ronnie Flex, Nick Schilder en Typhoon.',
    bgImage: streamersBg,
    image: streamers,
  },
  {
    id: 'theater',
    title: 'Samen naar het Theater',
    subtitle: 'Dé theatersensatie Harry Potter en het Vervloekte Kind',
    infoTitle: 'Harry Potter en het Vervloekte Kind',
    info: 'Twee tickets voor Harry Potter en het Vervloekte Kind, inclusief arrangement.',
    color: '#1b1624',
    image: theater,
  },
]
